import script from "./RichTextEditor.vue?vue&type=script&setup=true&lang=ts"
export * from "./RichTextEditor.vue?vue&type=script&setup=true&lang=ts"

import "./RichTextEditor.vue?vue&type=style&index=0&id=44813e26&lang=css"

const __exports__ = script;

export default __exports__